/*
 * world-cup-banner.js
 *
 * Hooks into a countdown-condensed section that has data-wc-mode="true"
 * and replaces its label + countdown target with the next upcoming
 * World Cup 2026 match scheduled for the viewer's local "today".
 *
 * Section is hidden when there are no remaining matches in the viewer's
 * local calendar day. The viewer's local timezone drives "today".
 *
 * The countdown itself is the Prestige theme's <countdown-timer> web
 * component; we only update its expires-at attribute, which it observes.
 */

(function () {
  var SCHEDULE_URL = window.WC_BANNER_SCHEDULE_URL;
  if (!SCHEDULE_URL) return;

  function isSameLocalDay(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function pickNextMatch(matches, now) {
    var upcoming = [];
    for (var i = 0; i < matches.length; i++) {
      var m = matches[i];
      var kickoff = new Date(m.kickoff);
      if (isNaN(kickoff.getTime())) continue;
      if (kickoff.getTime() <= now.getTime()) continue;
      if (!isSameLocalDay(kickoff, now)) continue;
      upcoming.push({ match: m, kickoff: kickoff });
    }
    if (upcoming.length === 0) return null;
    upcoming.sort(function (a, b) {
      return a.kickoff.getTime() - b.kickoff.getTime();
    });
    return upcoming[0];
  }

  // Format the kickoff in US Central time (the "CST" label is colloquial —
  // technically CDT in summer, but that's how American users read it).
  function formatKickoff(date) {
    var tz = 'America/Chicago';
    var datePart;
    var timePart;
    try {
      datePart = date.toLocaleDateString('en-US', {
        month: 'short', day: 'numeric', timeZone: tz
      }).toUpperCase();
      timePart = date.toLocaleTimeString('en-US', {
        hour: 'numeric', minute: '2-digit', timeZone: tz
      });
    } catch (_) {
      // Locale fallback — should never trigger on modern browsers.
      datePart = (date.getUTCMonth() + 1) + '/' + date.getUTCDate();
      timePart = date.getUTCHours() + ':' + ('0' + date.getUTCMinutes()).slice(-2) + ' UTC';
    }
    return { date: datePart, time: timePart };
  }

  function renderMatch(root, pick) {
    var t = formatKickoff(pick.kickoff);
    var matchup = pick.match.home + ' vs ' + pick.match.away;
    var label = t.date + ' · ' + t.time + ' CST · ' + matchup;

    var textNode = root.querySelector('.countdown-condensed__text .prose p');
    if (textNode) textNode.textContent = label;

    // Keep the right-side link (text + URL come from the section settings,
    // so they're editable from the Shopify theme editor).

    // No countdown in this variant — strip the timer entirely so the layout
    // collapses to a single info line.
    var timer = root.querySelector('countdown-timer');
    if (timer) timer.remove();

    root.style.removeProperty('display');
  }

  function hideBanner(root) {
    root.style.display = 'none';
  }

  function applyToRoot(root, schedule) {
    var pick = pickNextMatch(schedule.matches || [], new Date());
    if (pick) {
      renderMatch(root, pick);
    } else {
      hideBanner(root);
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-wc-mode="true"]');
    if (!roots.length) return;

    fetch(SCHEDULE_URL, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('schedule fetch failed: ' + r.status);
        return r.json();
      })
      .then(function (schedule) {
        roots.forEach(function (root) {
          applyToRoot(root, schedule);
        });

        // Re-evaluate every 60s so the banner rolls to the next match
        // automatically once the current one kicks off.
        setInterval(function () {
          roots.forEach(function (root) {
            applyToRoot(root, schedule);
          });
        }, 60 * 1000);
      })
      .catch(function () {
        // On any failure, just hide so we don't leave a stale
        // "Copa Mundial Kickoff" message up.
        roots.forEach(hideBanner);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
